import { createApp } from 'vue'
import store from './store/index'
import './assets/css/public.scss';
import ElementPlus from 'element-plus'
import App from './App.vue'
import router from './router/index'
import { lazyPlugin } from '@/directive'
//引入bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';  
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import '@/assets/css/reset.css';
import 'element-plus/dist/index.css'
import '@/assets/css/common.css';
import "@/router/permission"
//引入element图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import i18n from "@/lang/index";
// import 'amfe-flexible';
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
app.use(router).use(store).use(ElementPlus).use(lazyPlugin).use(i18n).mount('#app')
